import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IStatusIconProps extends IConDefaultType {}

export default function StatusIcon({ color, className, size = 40, rotate, flip, style }: IStatusIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 14C6 14.5523 6.44772 15 7 15H15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13H7C6.44772 13 6 13.4477 6 14ZM7 10.5C6.44772 10.5 6 10.0523 6 9.50001C6 8.94773 6.44772 8.50001 7 8.50001H11C11.5523 8.50001 12 8.94773 12 9.50001C12 10.0523 11.5523 10.5 11 10.5H7ZM17.6102 8.9C17.6102 9.39706 18.0131 9.8 18.5102 9.8H18.6902C19.1873 9.8 19.5902 9.39706 19.5902 8.9V6.39H22.1002C22.5973 6.39 23.0002 5.98706 23.0002 5.49V5.31C23.0002 4.81294 22.5973 4.41 22.1002 4.41H19.5902V1.9C19.5902 1.40294 19.1873 1 18.6902 1H18.5102C18.0131 1 17.6102 1.40294 17.6102 1.9V4.41H15.1002C14.6031 4.41 14.2002 4.81294 14.2002 5.31V5.49C14.2002 5.98706 14.6031 6.39 15.1002 6.39H17.6102V8.9ZM6.5 1.00001H12V1.00006L12.01 1.00001C12.5623 1.00001 13.01 1.44773 13.01 2.00001C13.01 2.5523 12.5623 3.00001 12.01 3.00001L12 2.99996V3.00001H6.5C4.63144 3.00001 3.10487 4.46429 3.00518 6.30798L3 6.50001V17.5C3 19.3686 4.46428 20.8951 6.30796 20.9948L6.5 21H17.5C19.3686 21 20.8951 19.5357 20.9948 17.692L21 17.5V12.01V12H21C21.0054 11.4523 21.4511 11.01 22 11.01C22.5489 11.01 22.9946 11.4523 23 12H23V12.01V17.5C23 20.5376 20.5376 23 17.5 23H6.5C3.46243 23 1 20.5376 1 17.5V6.50001C1 3.46245 3.46243 1.00001 6.5 1.00001Z"
          fill={color || '#8A8A8A'}
        />
      </svg>
    </i>
  );
}
